import { AppState } from './../app.state';
import { createReducer, Action, on, createFeatureSelector } from '@ngrx/store';
import * as actions from './base-data.actions';

export interface State {
  loading: boolean;
  loaded: boolean;
  error: any;
  nativeUploadsEnabled: boolean;
}

export const initialState: State = {
  loaded: false,
  loading: false,
  error: null,
  // Enabled until the server says otherwise. A server that has not had the
  // constance flag migrated in omits the field entirely, and defaulting to
  // false there would silently disable the feature everywhere.
  nativeUploadsEnabled: true,
};

const baseDataReducer = createReducer(
  initialState,
  on(actions.loadAllBaseData, state => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),
  on(actions.loadAllBaseDataSuccess, (state, { nativeUploadsEnabled }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    nativeUploadsEnabled,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return baseDataReducer(state, action);
}

export const selectBaseData = createFeatureSelector<State>('baseData');
